// src/components/recording/ModeRouteGuard.jsx
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useActiveMeasurementSession } from "../../recording/session/ActiveMeasurementSessionContext";
import { ActiveMeasurementSessionStore } from "../../recording/session/activeMeasurementSession";

export default function ModeRouteGuard({ mode, children }) {
  const { active } = useActiveMeasurementSession();
  const location = useLocation();
  const liveActive = ActiveMeasurementSessionStore.get() ?? active;

  if (!liveActive) {
    return (
      <Navigate
        to="/home"
        replace
        state={{ from: location.pathname + location.search, reason: "no_mode" }}
      />
    );
  }

  if (liveActive.mode !== mode) {
    return (
      <Navigate
        to="/home"
        replace
        state={{
          from: location.pathname + location.search,
          reason: "wrong_mode",
        }}
      />
    );
  }

  return children;
}

export function EndSessionOnUnmount({ reason = "route_unmount", children }) {
  const { end } = useActiveMeasurementSession();

  useEffect(() => {
    // StrictMode-safe: mark "committed" on next tick.
    // The dev-only fake cleanup runs before this, so it won't end the session.
    let committed = false;
    const t = setTimeout(() => {
      committed = true;
    }, 0);

    return () => {
      clearTimeout(t);
      if (!committed) return; // ignore StrictMode fake cleanup
      end(reason);
    };
  }, [end, reason]);

  return children;
}
